const ls = window.localStorage
export function freshSL(key, data) {
  const now = new Date().getTime()
  const ov = ls.getItem(key)
  if (ov) {
    ls.removeItem(key)
    ls.setItem(key, JSON.stringify({
      t: now,
      v: data
    }))
  } else {
    ls.setItem(key, JSON.stringify({
      t: now,
      v: data
    }))
  }
}
export function getSL(key) {
  return ls.getItem(key)
}
export function removeSL(key) {
  ls.removeItem(key)
}

// 对url进行处理 a=1&b=2 -> {a:1,b:2}
export const parse = (str) => {
  const obj = {}
  str.replace(/([^&=]+)=([^&=]+)/g, function() {
    obj[arguments[1]] = arguments[2]
  })
  return obj
}
// 对对象进行处理 {a:1,b:2} -> a=1&b=2
export const stringify = (obj) => {
  const arr = []
  for (const key in obj) {
    arr.push(`${key}=${obj[key]}`)
  }
  return arr.join('&')
}

// 时间处理
export function dateFormat(date, fmt) {
  if (date === 0) {
    return ''
  }
  if (typeof date === 'number') {
    date = new Date(date)
  } else if (typeof date === 'string') {
    const d = new Date(date)
    if (d !== 'Invalid Date') {
      date = d
    } else {
      date = new Date(date.replace(/-/g, '/'))
    }
  }
  if (!date) {
    return ''
  }

  fmt = fmt || 'yyyy-MM-dd'

  var o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (var k in o) { if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))) }
  return fmt
}

// 图片路径
export function filterImage(url) {
  if (!url || typeof url !== 'string') {
    return url
  }
  // return `http://new-dev.gxdcjg.com/uploads${url}`
  return `${location.origin}/uploads/${url}`
}

// 图片路径 觅单车
export function filterMiImage(url) {
  if (!url || typeof url !== 'string') {
    return url
  }
  if (location.port || location.href.indexOf('test2.gxdcjg.cn') > -1 || location.href.indexOf('test1.gxdcjg.cn') > -1) {
    return `https://test2.gxdcjg.cn/uploads${url}`
  } else {
    // return `https://zhmdc.lszhtc.com/uploads${url}`// 丽水
    return `https://seek.gxdcjg.com/uploads${url}`// 全国
  }
}

// excel 跳转下载
export function downloadExcel(url) {
  if (!url || typeof url !== 'string') {
    return url
  }
  // window.open(`http://new-dev.gxdcjg.com/uploads/${url}`)
  window.open(`${location.origin}/uploads/${url}`)
}

// 根据当前hash，获取完成hash
export function getHash(key) {
  let arr = location.hash.split('/')
  if (arr.length > 2) {
    if (arr[1] === 'CompanyManagement') {
      arr = arr.slice(0, 3)
    } else {
      arr = arr.slice(0, 2)
    }
  }
  arr.push(key)
  return arr.join('/')
}

export function getFilterParams(params) {
  const obj = {}
  Object.keys(params).forEach(key => {
    if (params[key] || params[key] === '0' || params[key] === 0) {
      obj[key] = params[key]
    }
  })
  return obj
}

export function lookPDF(url) {
  if (!url || typeof url !== 'string') {
    return url
  }
  window.open(filterImage(url))
}

/**
* @desc 获取全部url参数
*/
export function getUrlParam() {
  var href = decodeURIComponent(window.location.href); var obj = {}
  var search = href.split('?')[1]
  if (search) {
    var arr = search.split('&')
    arr.forEach((item) => {
      if (item.indexOf('=') > -1) {
        var temp = item.split('=')
        obj[temp[0]] = temp[1]
      } else {
        obj[item] = ''
      }
    })
  }
  return obj
}

export function getAddressNameForArea(id, lists) {
  if (!id || !lists) {
    return ''
  }
  const address = lists.find(it => it.id === id)
  if (address) {
    return address.areaName
  }
  return ''
}

export function getAddressNamesForArea(id, lists, child) {
  if (Number(id) === 0) {
    return '全国'
  }
  if (!id || !lists) {
    return ''
  }
  if (!child) {
    child = []
  }
  const address = lists.find(it => it.id === id)
  child.unshift(address)
  if (address && !address.parentId) {
    return child.map(it => it.areaName).join(',')
  } else {
    return getAddressNamesForArea(address.parentId, lists, child)
  }
}

export function compare(a, b) {
  return a - b
}


// 经纬度转换成三角函数中度分表形式。
export function rad(d) {
  return d * Math.PI / 180.0;
}


// 根据经纬度计算距离，参数分别为第一点的纬度，经度；第二点的纬度，经度
export function getDistance(lat1, lng1, lat2, lng2) {

  var radLat1 = rad(lat1);
  var radLat2 = rad(lat2);
  var a = radLat1 - radLat2;
  var b = rad(lng1) - rad(lng2);
  var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) +
    Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
  s = s * 6378.137; // EARTH_RADIUS;
  s = Math.round(s * 10000) / 10000; //输出为公里

  s=s.toFixed(4);

  var distance = s;
  var distance_str = "";

  if (parseInt(distance) >= 1) {
    distance_str = distance.toFixed(1) + "km";
  } else {
    distance_str = (distance * 1000).toFixed(4) + "m";
  }



  // console.info('lyj 距离是', s);
  // console.info('lyj 距离是', distance_str);
  return distance_str;
}
